import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import { Modal } from 'react-bootstrap';
import * as Api from 'api';
import { MapForm, ToggleSwitch } from 'components';
import { emit } from 'utils';

class EditMapModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);

    this.map_before_edit = null;
  }

  handleSave(current_map) {
    emit('edit-map', { data: current_map })
    .catch(this.props.notify)
    .finally(() => this.props.toggleShowEditMapModal(false));

    if(this.map_before_edit.properties.finished != current_map.properties.finished) {
      this.props.toggleMarkCurrentMapFinished(current_map.properties.finished);
    }
  }
  componentDidUpdate(prev_props) {
    const prev_show = prev_props.mapCreator.show_edit_map_modal;
    const current_show = this.props.mapCreator.show_edit_map_modal;
    if(prev_show != current_show) {
      if(current_show == true) {
        this.map_before_edit = this.props.mapCreator.current_map;
      }
      else {
        this.map_before_edit = null;
      }
    }
  }

  render() {
    const {
      show_edit_map_modal,
      current_map
     } = this.props.mapCreator;

    return current_map ? (
      <Modal
        show={show_edit_map_modal}
        onHide={this.props.cancelEditMap}
        >
        <MapForm
          title='Map Info'
          map={current_map}
          cancelEditMap={this.props.cancelEditMap}
          handleSave={this.handleSave}
        />
      </Modal>
    ) : null;
  }
}

export default mapCreatorConnect(EditMapModal);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/edit-map-modal.js